import { createAction, props } from '@ngrx/store';
import { create } from 'domain';
import { RouteDetails } from '../../../shared/models/route-details';

export const getRoutes = createAction(
  '[Tracks] Get Routes',
  props<{unitIds: number[], dateFrom: string, dateTo: string}>()
);
export const getRoutesSummary = createAction(
  '[Tracks] Get Routes Summary',
  props<{unitIds: number[], dateFrom: string, dateTo: string}>()
);
export const cancelRoutesSummary = createAction(
  '[Tracks] Cancel Routes Summary'
);

export const selectRoutes = createAction(
  '[Tracks] Select Routes',
  props<{routes: RouteDetails[]}>()
);

export const clickedRoutes = createAction(
  '[Tracks] Clicked Routes',
  props<{routesIds: string[]}>()
);
export const hoveredRoutes = createAction(
  '[Tracks] Hovered Routes',
  props<{routesIds: string[]}>()
);

export const clickedStopRoutes = createAction(
  '[Tracks] Clicked Stop Routes',
  props<{routesIds: string[]}>()
);
export const hoveredStopRoutes = createAction(
  '[Tracks] Hovered Stop Routes',
  props<{routesIds: string[]}>()
);

export const clearStopRoutes = createAction(
  '[Tracks] Clear Stop Routes'
);

export const getDate = createAction(
  '[Tracks] Get Date'
);
export const setDate = createAction(
  '[Tracks] Set Date',
  props<{date: {dateFrom: string, dateTo: string }}>()
);
export const clearRoutes = createAction(
  '[Tracks] Clear Routes'
);
export const clearRoutesCache = createAction(
  '[Tracks] Clear Routes Cache'
);

export const clearSelectedVehicles = createAction(
  '[Tracks] Clear Selected Vehicles'
);

export const addClickedRoute = createAction(
  '[Tracks] Add Clicked Route',
  props<{routeId: string}>()
);

export const removeClickedRoute = createAction(
  '[Tracks] Remove Clicked Route',
  props<{routeId: string}>()
);

export const addHoveredRoute = createAction(
  '[Tracks] Add Hovered Route',
  props<{routeId: string}>()
);

export const removeHoveredRoute = createAction(
  '[Tracks] Remove Hovered Route',
  props<{routeId: string}>()
);

export const addClickedStopRoute = createAction(
  '[Tracks] Add Clicked Stop Route',
  props<{routeId: string}>()
);

export const removeClickedStopRoute = createAction(
  '[Tracks] Remove Clicked Stop Route',
  props<{routeId: string}>()
);

export const addHoveredStopRoute = createAction(
  '[Tracks] Add Hovered Stop Route',
  props<{routeId: string}>()
);

export const removeHoveredStopRoute = createAction(
  '[Tracks] Remove Hovered Stop Route',
  props<{routeId: string}>()
);
export const routeGoBack = createAction(
  '[Tracks] Route Go Back'
);
export const selectActivePlayer = createAction(
  '[Tracks] Select Active Player',
  props<{uuid: string}>()
);
export const selectVehicles = createAction(
  '[Tracks] Select Vehicles',
  props<{unitIds: number[]}>()
);
export const vehiclesDetailsVisibility = createAction(
  '[Tracks] Vehicles Details Visibility',
  props<{visible: boolean}>()
);
export const setRoutesByUnitIds = createAction(
  '[Tracks] Set Route By Unit Ids',
  props<{unitIds: number[]}>()
);
export const chooseRoute = createAction(
  '[Tracks] Choose Route',
  props<{route: RouteDetails}>()
);
export const setRoutesLoading = createAction(
  '[Tracks] Set Routes Loading',
  props<{isLoading: boolean}>()
);

export const reset = createAction(
  '[Tracks] Reset'
);

export type TracksActionsUnion = ReturnType<
  typeof getRoutes |
  typeof getRoutesSummary |
  typeof cancelRoutesSummary |
  typeof getDate |
  typeof setDate |
  typeof selectRoutes |
  typeof clickedRoutes |
  typeof hoveredRoutes |
  typeof clickedStopRoutes |
  typeof hoveredStopRoutes |
  typeof clearStopRoutes |
  typeof clearRoutes |
  typeof clearRoutesCache |
  typeof clearSelectedVehicles |
  typeof addClickedRoute |
  typeof removeClickedRoute |
  typeof addHoveredRoute |
  typeof removeHoveredRoute |
  typeof addClickedStopRoute |
  typeof removeClickedStopRoute |
  typeof addHoveredStopRoute |
  typeof removeHoveredStopRoute |
  typeof routeGoBack |
  typeof selectActivePlayer |
  typeof selectVehicles |
  typeof vehiclesDetailsVisibility |
  typeof setRoutesByUnitIds |
  typeof chooseRoute |
  typeof setRoutesLoading |
  typeof reset
  >;
